import Vue from 'vue'
import VueI18n from 'vue-i18n'
import moment from 'moment'
import App from './App.vue'


// 'Mobile' or not analysis
const deviceAgent = navigator.userAgent.toLowerCase();

Vue.prototype.$isMobile = !!(deviceAgent.match(/(iphone|ipod|ipad)/) ||
  deviceAgent.match(/(android)/) ||
  deviceAgent.match(/(iemobile)/) ||
  deviceAgent.match(/iphone/i) ||
  deviceAgent.match(/ipad/i) ||
  deviceAgent.match(/ipod/i))

// Localization
const userLang = navigator.language || navigator.userLanguage
Vue.prototype.$languageId = userLang.toLowerCase().startsWith('fr') ? 'fr' : 'en'
moment.locale(Vue.prototype.$languageId)

const messages = {
  fr: {
    errorMissingDeviceHash: "Erreur : il manque l'identifiant de balise dans l'URL, ou celui-ci est incorrect.",
    indicatorLastUpdate: 'Dernière vérification à {date}',
    enabledPurifier: 'Votre purificateur est connecté',
    runningPurifier: 'Votre purificateur est en marche',
    loginHelp: 'Saisissez le code à 4 chiffres mis à disposition par votre hôte'
  },
  en: {
    errorMissingDeviceHash: "Error : the device identifier was not found in the URL, or is unknown.",
    indicatorLastUpdate: 'Last check at {date}',
    enabledPurifier: 'Your purifier is connected',
    runningPurifier: 'Your purifier is running',
    loginHelp: 'Enter the 4 digit code given to you by your host'
  }
}

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: Vue.prototype.$languageId,
  fallbackLocale: 'en',
  messages
})

// Fetch global method
Vue.prototype.$fetch = async function (path, isResponseRawText) {
  const url = process.env.API_URL + "/" + path;

  const response = await fetch(url, {
    method: 'GET'
  });

  if (response.ok) {
    if (isResponseRawText) {
      return await response.text();
    }
    else {
      return await response.json();
    }
  }

  return null
}

// Get the device parameters
const url = new URL(window.location.href)
const deviceHash = url.pathname.slice(1)

// Start...
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  components: { App },
  template: `<App deviceHash='${deviceHash}'/>`
})



// WEBPACK FOOTER //
// ./src/main.js